import * as api from '@/core/apis';

const DEFAULT_TIMEZONE_ATTRIBUTE_TYPE = 50084;
const INDIVIDUAL = 'individual';
const ORGANISATION = 'organisation';

export async function getCache() {
    return await api.get(`/account/cache`);
}

export async function setCache(data) {
    return await api.post(`/account/cache`, data);
}

export async function getAccountType() {
    return await api.get(`/account-type`);
}

export async function getAccountProfileOption(accountId) {
    return await api.get(`/account-profile/${accountId}/account`);
}

export async function getAccount(accountId) {
    return await api.get(`/account/${accountId}`);
}

/**
 *
 * @param {*} accountId
 * @returns
 */
export async function fetchAccountDetails(accountId) {
    return await api.post(`account/load-account-details/${accountId}`);
}

export async function getDefaultAccountSettings(accountId) {
    return await api.get(`/account/default-account-settings/${accountId}`);
}

export async function getDefaultBillingTradingTerms(accountId) {
    return await api.get(`/account/default-billing-trading-terms/${accountId}`);
}

export async function getDefaultMarketingSettings() {
    return await api.get(`/account/default-marketing-settings`);
}

export async function getDefaultCreditSettings(accountId) {
    return await api.get(`/account/default-credit-settings/${accountId}`);
}

export async function getDefaultAccountGroup() {
    return await api.get(`/account/default-account-group`);
}

export async function getDefaultInvoiceSettings(accountId) {
    return await api.get(`/account/default-invoice-settings/${accountId}`);
}

export async function createAccount(data) {
    return await api.post(`/account/store`, data);
}

export async function saveAccountTimezone(data) {
    return await api.post(`/account/save-attribute-value`, data);
}

export function getTimezoneAttributeType() {
    return DEFAULT_TIMEZONE_ATTRIBUTE_TYPE;
}

export function getIndividual() {
    return INDIVIDUAL;
}

export function getOrganisation() {
    return ORGANISATION;
}

/**
 * For End-User Portal - Accounts Summary
 */

export async function getAccountSummaryPayments(accountId) {
    return await api.get(`/account/payments/${accountId}`);
}

export async function getAccountSummaryInvoices(accountId) {
    return await api.get(`/account/invoices/${accountId}`);
}

export async function getAccountSummaryBilling(accountId) {
    return await api.get(`/account/billing/${accountId}`);
}

export async function getAccountStatus() {
    return await api.get(`/account-status`);
}

export async function quickCreateAccount(payload) {
    return await api.post('/account/quick-create',payload);
}
